module.exports = "/_next/static/images/243c3a21fbbad86e4e24bda5cf70284f-insurance-life-marketing-link.jpg.webp";